import { server } from '../core/server/axios';
import { BACKEND_URL } from '@/core/config';

export interface AddCurrencyCashVariables {
    balance: number;
    currencyCode: string;
    kassaId?: string | number;
    currencyId: string | number;
    reserved: number;
    serialNumber: string;
    incomeRate: number;
    incomeAmount: number;
    actionType: "outcome" | "income";
    login: string;
    comment: string;
    cashierIin: string;
}

export interface UpdateCurrencyCashVariables {
    cashId: number;
    balance: number;
    login: string;
    cashType: string
    cashTypeDescription: string
    currencyCode: string;
    serialNumber: string;
    incomeRate: number;
    incomeAmount: number;
    actionType: "outcome" | "income";
    comment: string;
    cashierIin: string;
}

export interface TransferCashBetweenKassaVariables {
    fromId: string | number;
    toId: string | number;
    currencyId: string | number;
    currencyCode: string;
    amount: number;
    initiator: string;
}

export interface CashAccept {
    id: number;
    depId: number;
    kassaId: number;
    currencyId: number;
    currencyCode: string;
    cashId: number;
    amount: number;
    rate: number;
    nbRate: number;
    wacRate: number;
    createdBy: string;
    actionType: 0 | 1 | 2 | 3; //0 - приход; 1 - снятие; 2 - приход от БВУ; 3 - снятие для БВУ
    goldSerial: string;
    acceptedBy: string;
    status: 0 | 1 | 2 | 3 | 4 | 5 | 6; //0 - создан; 1 - принят; 2 - отклонен; 3 - БВУ сохранен; 4 - БВУ создан; 5 - БВУ принят; 6 - БВУ отклонен;
    operationNumber: string;
    agreementId: number;
    createdAt: Date;
    acceptedAt: Date;
    comment: string;
}

/** Создание акцепта: номера слитков уходят массивом, а не строкой через запятую */
export type NewCashAccept = Omit<CashAccept, "id" | "operationNumber" | "createdAt" | "acceptedAt" | "createdBy" | "goldSerial"> & {
    goldSerial: string;
};

export class CashController {
    async addCurrencyCash(request: AddCurrencyCashVariables) {
        return await server.post('/Cash/balance', request, {
            baseURL: BACKEND_URL
        });
    }

    async updateCurrencyCash({
        cashId,
        balance,
        login,
        cashType,
        cashTypeDescription,
        currencyCode,
        serialNumber,
        incomeRate,
        incomeAmount,
        actionType,
        comment,
        cashierIin
    }: UpdateCurrencyCashVariables) {
        return await server.post(`/Cash/balanceUpdate`, {
            cashId,
            balance,
            login,
            cashType,
            cashTypeDescription,
            currencyCode,
            serialNumber,
            incomeRate,
            incomeAmount,
            actionType,
            comment,
            cashierIin
        }, {
            baseURL: BACKEND_URL
        });
    }

    async transferCashBetweenKassa(request: TransferCashBetweenKassaVariables) {
        return await server.post('/Department/cashTransfer', request, {
            baseURL: BACKEND_URL
        });
    }

    async ofdCash({ operation, sum, id }: { operation: "ins" | "exp", sum: number, id?: string | number }) {
        return await server.post(`EcashCore/moneyPlacement?id=${id}&operation=${operation}&sum=${sum}`, {}, {
            baseURL: BACKEND_URL
        });
    }

    async newAccept(request: NewCashAccept): Promise<CashAccept> {
        return await server.post(`/Cash/newAccept`, request, {
            baseURL: BACKEND_URL
        });
    }

    async updateAccept(request: { status: number, id: number, comment?: string }) {
        return await server.post(`/Cash/updateAccept`, request, {
            baseURL: BACKEND_URL
        });
    }

    async getAccepts({ depsId, from, to, page = 1, size = 20 }: { depsId: number[], from: Date | null, to: Date | null, page: number, size: number }): Promise<CashAccept[]> {
        return await server.post(`/Cash/getAccepts`,
            {
                depId: depsId,
                from,
                to,
                page,
                size
            },
            {
                baseURL: BACKEND_URL
            });
    }

    async getAccept(id: number): Promise<CashAccept> {
        return await server.get(`/Cash/getAccept/${id}`, {
            baseURL: BACKEND_URL
        });
    }
} 